var _jsxFileName = "/repo/packages/ippm/src/components/IppmApp/index.js",
  _this = this;
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ExperimentProvider } from '../../utils/experimentContext';
import AppContextProvider from '../../utils/appContext';
import BackToSurvey from '../BackToSurvey';
import Headline from '../Headline';
import PackagesContainer from '../PackagesContainer';
import Disclaimer from '../Disclaimer';
import './IppmApp.scss';
var IppmApp = function IppmApp(_ref) {
  var strings = _ref.strings,
    appData = _ref.appData,
    handleCloseIPPM = _ref.handleCloseIPPM;
  var cls = classNames({
    ie: false,
    ippmApp: true
  });
  var handleBackToSurveyClick = function handleBackToSurveyClick() {
    handleCloseIPPM();
  };
  return /*#__PURE__*/React.createElement(AppContextProvider, {
    appData: appData,
    strings: strings,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ExperimentProvider, {
    experiments: appData.experiments,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: cls,
    "data-ucs-render-id": 1234,
    "data-ucs-module-name": "ippm",
    "data-testid": "IppmApp",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 9
    }
  }, handleCloseIPPM ? /*#__PURE__*/React.createElement(BackToSurvey, {
    onBackToSurveyClick: handleBackToSurveyClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 13
    }
  }) : null, /*#__PURE__*/React.createElement(Headline, {
    onBackToSurveyClick: handleBackToSurveyClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(PackagesContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(Disclaimer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 11
    }
  }))));
};
IppmApp.defaultProps = {
  strings: {},
  handleCloseIPPM: undefined
};
IppmApp.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  handleCloseIPPM: PropTypes.func,
  appData: PropTypes.shape({
    // Experiments is an object mapping experiment IDs to treatment IDs, or null
    experiments: PropTypes.objectOf(PropTypes.string).isRequired,
    packages: PropTypes.arrayOf(PropTypes.shape({
      // Package ID, as a number
      id: PropTypes.number.isRequired,
      // Label describing the billing frquency
      billing_frequency: PropTypes.string.isRequired,
      // Cost as a formatted string (cont. HTML)
      cost: PropTypes.string.isRequired,
      // Monthly cost in cents
      monthly_cost_raw: PropTypes.number.isRequired,
      // Default features is passed in a relatively odd format in the original appData:
      // { feature_name: { label: ..., included: ... }}
      // This should eventually refactored into something more sensible
      default_features: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        included: PropTypes.bool.isRequired
      }))),
      // Label for "included in this plan"
      included_in_label: PropTypes.string.isRequired,
      // Maps IDs to feature definitions.
      // It looks like the ID is matching the name, so this should
      // probably be returned as a graphql-friendly array of objects
      // instead, and built into a map as / if needed.
      features: PropTypes.objectOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        level: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired]).isRequired,
        label: PropTypes.string.isRequired,
        included: PropTypes.bool.isRequired
      }).isRequired),
      // Versions data
      package_label: PropTypes.string.isRequired,
      price_display: PropTypes.string.isRequired,
      swap_link: PropTypes.string,
      upgrade_link: PropTypes.string,
      tier: PropTypes.number,
      associated_package: PropTypes.number,
      class_name: PropTypes.string,
      savings_percentage: PropTypes.number,
      // "Per month message", usually either one of:
      // - '/ month' (for individual plans)
      // - '/ user / month' (for team plans)
      per_month_message: PropTypes.string

      // grow_starter_annual -> should not be passed
      // communicate_response_limit_features -> also get rid of this
    })),

    eduDiscountAvailable: PropTypes.bool.isRequired,
    // Paid features that were added to TBYB, as wall_* features
    addedPaidFeatures: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    // List of highlighed feature IDs
    highlightedFeatures: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    overageCostInfo: PropTypes.shape({
      has_overage_cost: PropTypes.bool.isRequired,
      overage_cost: PropTypes.string // Formatted string
    }),

    // Current feature set ID for the user
    featureSetId: PropTypes.number.isRequired
  }).isRequired
};
export default IppmApp;